export class User {
  id: number;
  email: string;
  username: string;
  firstName: string;
  lastName: string;
  idCardNo: number;
  address: string;
  role: string;
  password: string;
  confirmPassword: string;
  token: string;
  managerId: number;
  visitorStatus:number;
  comment:string;
  room: any;
  operaterId:number
  
  constructor() {
    this.id = null;
    this.email = '';
    this.username = '';
    this.firstName = '';
    this.lastName = '';
    this.idCardNo = null;
    this.address = '';
    this.role = '';
    this.password = '';
    this.confirmPassword = '';
    this.token = '';
    this.managerId = null;
    this.visitorStatus=null;
    this.comment='';
    this.operaterId=null;
    

  }
}
